import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm q-my-sm" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row q-gutter-sm q-my-sm" }
const _hoisted_4 = { class: "col" }

import { Timer } from 'app/types/timers'
import { Ref, inject, onBeforeMount, ref } from 'vue'
import { isValidDate, toDate, stripTime } from '../utils'
import { useStartEndRules } from '../composables/startEndRules'
import { useChildTimerRules } from '../composables/useChildTimerRules'
import { useFormatDate } from '../composables/formatDate'
import { useI18n } from 'vue-i18n'
import BaseModal from './wrappers/BaseModal.vue'
import { useModelWrapper } from './wrappers/helpers/useModelWrapper'
import { useTimers } from '../store/timers'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormChildTimer',
  props: {
    timer: {},
    modelValue: { type: Boolean },
    parentIndex: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const value = useModelWrapper(props, emit)

const date = inject('date', ref(new Date()))
const { t } = useI18n({ useScope: 'global' })
const formLabel = (key: string) => t(`form.${key}`)
const activityLabel = (key: string) => t(`activities.${key}`)

const start = ref<Date>(new Date())
stripTime(start, date.value)
const end = ref()
const startRef = ref()
const endRef = ref()

const rules = useStartEndRules({ start, end })
const childRules = useChildTimerRules()

onBeforeMount(() => {
  start.value = props.timer.children[props.timer.children.length - 1].start_time
  stripTime(start, date.value)
  end.value = props.timer.children[props.timer.children.length - 1].end_time ?? undefined
  if (end.value) {
    stripTime(end, date.value)
  }
})
const validate = () => {
  if (startRef.value) {
    startRef.value.validate()
    if (startRef.value.hasError) return false
  }
  if (endRef.value) {
    endRef.value.validate()
    if (endRef.value.hasError) return false
  }
  return true
}
const updateTimer =
  (timerRef: Ref<Date>) =>
  (date: Date): void => {
    timerRef.value = date
  }
updateTimer(start)
const updateEnd = updateTimer(end)

const { editChildStartEnd } = useTimers()
const editActivity = () => {
  if (validate()) {
    stripTime(start, date.value)
    stripTime(end, date.value)

    if (end.value) {
      editChildStartEnd(
        { start_time: start.value, end_time: end.value },
        props.parentIndex,
        props.timer.children.length - 1
      )
    }
    value.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(`${activityLabel('storeTask')}: ${_ctx.timer.children[_ctx.timer.children.length - 1].data.task_id}`), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_input, {
            ref_key: "startRef",
            ref: startRef,
            "model-value": 
              _unref(useFormatDate)(start.value).time({
                hour: 'numeric',
                minute: 'numeric',
                hourCycle: 'h23',
              })
            ,
            readonly: "",
            color: "accent",
            filled: "",
            type: "time",
            label: formLabel('startTime')
          }, null, 8, ["model-value", "label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_input, {
            ref_key: "endRef",
            ref: endRef,
            "model-value": 
              _unref(useFormatDate)(end.value).time({
                hour: 'numeric',
                minute: 'numeric',
                hourCycle: 'h23',
              })
            ,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => (_unref(isValidDate)(val) ? _unref(updateEnd)(_unref(toDate)(val, start.value) as Date) : undefined)),
            rules: [
              (val) => _unref(isValidDate)(val) || '',
              (val) => _unref(rules).beforeNow(_unref(toDate)(val, start.value) as Date) || formLabel('notBeforeNow'),
              (val) => _unref(rules).notBetweenTimers(_unref(toDate)(val, start.value) as Date, _ctx.parentIndex) || formLabel('betweenActivities'),
              (val) => _unref(childRules).newSumChildrenNotGreaterThanParent(
                { start_time: _unref(toDate)(start.value, start.value) as Date, end_time: _unref(toDate)(val, start.value) as Date }, _ctx.parentIndex, _ctx.timer.children.length - 1)
                || formLabel('childrenSum'),
              () =>
                _unref(useChildTimerRules)().notBeforeStart({ childStart: start.value, childEnd: end.value }, _ctx.timer) ||
                formLabel('endOverlapStart'),
            ],
            color: "accent",
            filled: "",
            type: "time",
            label: formLabel('endTime')
          }, null, 8, ["model-value", "rules", "label"])
        ])
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_q_btn_dropdown, {
        color: "primary",
        split: "",
        onClick: editActivity,
        label: `${formLabel('save')} ${activityLabel('storeTask')}`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(formLabel('cancel')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup, 2]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})